<template>
    <tr class="workflows__log_table_item_collapse_table_item">
        <td class="workflows__log_table_item_collapse_table_item_learner">{{ workflowLearner }}</td>
        <td class="workflows__log_table_item_collapse_table_item_reason">{{ workflowReason }}</td>
        <td class="workflows__log_table_item_collapse_table_item_blank"></td>
    </tr>
</template>

<script>

export default {
  name: 'lms-superadmin-workflows-log-table-item-collapse-table-item',
  props: {
    item: {
      type: Object
    }
  },
  computed: {
    workflowLearner () {
      return this.item.userName || '-'
    },
    workflowReason () {
      return this.item.comment || '-'
    }
  }
}
</script>
